import styled, { css } from "styled-components";
import { theme } from "../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint } from "../../../../../../common-deprecated/themes/common";
import * as ButtonStyles from "../../../../../../common-deprecated/styles/v2/lexus/globals/Button";

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    padding: 6.4rem ${theme.space[3]}px;
    border-bottom: 1px solid ${theme.colors.silver};
    border-right: 1px solid ${theme.colors.silver};

    @media ${getBreakpoint("down", "md")} {
        min-height: 49rem;
    }
`;

export const MediaWrapper = styled.div<{ lightImage?: boolean; showBackground?: boolean }>`
    position: absolute;
    inset: 0;
    object-fit: cover;
    background-color: ${({ showBackground }) => (showBackground ? "rgba(0, 0, 0, 0.4)" : "transparent")};
    overflow: hidden;
    z-index: -1;

    ${({ lightImage }) =>
        lightImage
            ? css`
                  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 59.25%);
              `
            : css`
                  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 59.25%);
              `};

    img,
    video {
        position: absolute;
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: -1;
    }
`;

export const Text = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 0;
    gap: ${theme.space[1] / 2}px;
`;

export const Title = styled.h2<{ lightImage?: boolean }>`
    margin: 0;
    padding: 0;
    font-family: ${theme.fonts.regular};
    font-size: 4.8rem;
    line-height: 1.25;
    text-align: start;
    text-shadow:
        0 15px 80px rgba(0, 0, 0, 0.04),
        0 4.5px 24.2px rgba(0, 0, 0, 0.05),
        0 1.9px 10.1px rgba(0, 0, 0, 0.03),
        0 0.7px 3.6px rgba(0, 0, 0, 0.02);
    text-transform: uppercase;

    ${({ lightImage }) =>
        lightImage
            ? css`
                  color: ${theme.colors.midnight};
              `
            : css`
                  color: ${theme.colors.white};
              `}
`;

export const Description = styled.div<{ lightImage?: boolean }>`
    font-family: ${theme.fonts.book};
    font-size: 1.6rem;
    line-height: 1.25;
    text-align: start;
    text-shadow:
        0 15px 80px rgba(0, 0, 0, 0.04),
        0 4.5px 24.2px rgba(0, 0, 0, 0.05),
        0 1.9px 10.1px rgba(0, 0, 0, 0.03),
        0 0.7px 3.6px rgba(0, 0, 0, 0.02);
    text-transform: uppercase;

    ${({ lightImage }) =>
        lightImage
            ? css`
                  color: ${theme.colors.midnight};
              `
            : css`
                  color: ${theme.colors.white};
              `}
`;

export const EcoLabel = styled.div<{ lightImage?: boolean }>`
    padding: ${theme.space[1] / 2}px;
    font-family: ${theme.fonts.book};
    font-size: 1.4rem;
    line-height: 1.5;
    text-align: start;
    text-shadow:
        0 15px 80px rgba(0, 0, 0, 0.04),
        0 4.5px 24.2px rgba(0, 0, 0, 0.05),
        0 1.9px 10.1px rgba(0, 0, 0, 0.03),
        0 0.7px 3.6px rgba(0, 0, 0, 0.02);

    ${({ lightImage }) =>
        lightImage
            ? css`
                  color: ${theme.colors.midnight};
              `
            : css`
                  color: ${theme.colors.white};
              `}
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    align-self: stretch;
    padding: 0;
    gap: ${theme.space[2]}px;

    a,
    button {
        margin: 0;
    }

    /* Override default button style because it shouldn't be shown fullwidth on mobile */
    ${ButtonStyles.ButtonWrapper} {
        width: auto;
    }
`;
